export default "__VITE_ASSET__bbf8eb6f__"